import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import chayanikaDoc from '../../../../assets/images/Doctorsimages/dr.Chayanika.png'
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const ChayanikaDoc = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    document.title = "Dr. Chayanika Ghosh | Best Dentist & Root Canal Specialist in Jayanagar, Bangalore";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Chayanika Ghosh (BDS, Fellowship in Endodontics), a trusted female dentist and root canal specialist in Jayanagar, Bangalore. Expert in smile designing, cosmetic dentistry, and affordable dental care with 4+ years of experience."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best dentist in Jayanagar Bangalore, female dentist in Bangalore, root canal specialist in Jayanagar, cosmetic dentist in Bangalore, smile designing dentist in Bangalore, affordable dental treatment in Jayanagar Bangalore, restorative dentist near me, endodontist in Bangalore, dental clinic in Jayanagar with expert dentist, best doctor for tooth pain in Bangalore, dental filling and cosmetic dentist in Bangalore"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-chayanika-ghosh-dentist-jayanagar-bangalore");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-chayanika-ghosh-dentist-jayanagar-bangalore");
      document.head.appendChild(canonicalLink);
    }
    
    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);


  const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');

  container.classList.add('veenadoc-pdf-mode');


  const originalStyles = new Map();


  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }


  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });


  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
     
      container.classList.remove('veenadoc-pdf-mode');

   
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

   
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

   
      const marginLeft = 10; 
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;

      
      const scaleFactor = availableWidth / canvasWidth;

  
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
       
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Chanyanika_M_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');

     
      container.classList.remove('veenadoc-pdf-mode');

      
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Chayanika Ghosh</span>
                  <span className="veenadoc-title-credentials">(BDS, Fellowship in Endodontics)</span>
                  <span className="veenadoc-title-location">Jayanagar, Bangalore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Widely recognized as one of the best dentists in Jayanagar, Bangalore, trusted by patients for her gentle approach, 
                    advanced clinical expertise, and strong commitment to oral healthcare. With more than 4 years of experience, 
                    she has successfully treated hundreds of patients in both general and specialized dentistry.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
                    className="veenadoc-btn-primary-gradient"
                    onClick={() => navigate('/bookconsultation')}
                  >
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={chayanikaDoc} alt="Dr. Chayanika Ghosh – Consultant Dentist & Root Canal Specialist in Jayanagar Bangalore" className="veenadoc-doctor-image" title='Dr. Chayanika Ghosh | Best Female Dentist in Bangalore' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>Dr. Chayanika Ghosh – Consultant Dentist & Centre Manager</h2>
                  <p>
                    Dr. Chayanika Ghosh (BDS, Fellowship in Endodontics) is widely recognized as one of the best dentists in Jayanagar, Bangalore, 
                    trusted by patients for her gentle approach, advanced clinical expertise, and strong commitment to oral healthcare. 
                    Known for her precision in endodontics and her dedication as a female dentist in Bangalore, Dr. Chayanika offers a perfect 
                    blend of technical excellence and compassionate patient care.
                  </p>
                  <p>
                    She began her journey at the renowned Sharavathi Dental College and Hospital, Shimoga, Karnataka, where she earned her 
                    Bachelor of Dental Surgery (BDS) degree. To further enhance her expertise, she pursued a Fellowship in Endodontics, 
                    specializing in advanced root canal treatments and restorative dentistry.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Professional Experience & Leadership</h2>
                  <p>
                    Over the course of her career, Dr. Chayanika has worked with reputed organizations such as 32 Signature Smiles, Agartala, 
                    and Clove Dental, Bangalore, where she also served as Clinic Head. In these roles, she not only treated patients but also 
                    managed teams, mentored junior dentists, and ensured world-class standards of dental care.
                  </p>
                  <p>
                   As a dedicated Centre Manager, Dr. Chayanika demonstrates exceptional leadership and a strong commitment to delivering high-quality dental care. Her ability to balance patient satisfaction with clinical excellence has earned her the trust of many across Bangalore. Patients looking for a  dentist in Jayanagar, Bangalore, often choose Dr. Chayanika for her patient-focused approach and unwavering dedication to their well-being.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">4+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Fellowship in Endodontics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Jayanagar, Bangalore</span>
                    </div>
                  </div>
                </div>

                {/* Root Canal Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Root Canal Specialist in Jayanagar</h2>
                  <p>
                    As a root canal specialist in Bangalore, she performs painless and effective treatments that save natural teeth and restore 
                    their function. Patients suffering from toothache, cracked teeth, or infections often find relief under her care. Her 
                    training in endodontics gave her the ability to manage even the most complex cases with precision.
                  </p>
                  <p>
                   She is dedicated to creating a pain-free, comfortable, and reassuring dental experience for every patient. Whether it is a child visiting for preventive care, someone undergoing root canal treatment, or an individual seeking a smile makeover, she delivers personalized care with exceptional precision and attention to detail.
                  </p>
                </div>

                {/* Cosmetic Dentistry */}
                <div className="veenadoc-article-block">
                  <h2>Cosmetic Dentist & Smile Designing Expert</h2>
                  <p>
                    She is also a trusted cosmetic dentist in Jayanagar, offering advanced procedures like smile designing, cosmetic fillings, 
                    and teeth whitening, helping patients achieve brighter, healthier, and more confident smiles. Those searching for the best 
                    dentist for smile designing in Bangalore often discover her because of her proven results in aesthetic dentistry.
                  </p>
                  <p>
                    Her expertise spans across multiple areas of dentistry, combining advanced skills with a compassionate approach. From minor 
                    cavities to complex tooth structure loss, her restorative work improves both function and aesthetics, ensuring long-lasting results.
                  </p>
                </div>

                {/* Preventive Care */}
                <div className="veenadoc-article-block">
                  <h2>Comprehensive Preventive Dental Care</h2>
                  <p>
                    In addition to restorative and cosmetic treatments, Dr. Chayanika is highly skilled in preventive care. Many patients look 
                    for a dental clinic in Jayanagar with expert dentists where they can receive regular check-ups, scaling, polishing, and 
                    cavity prevention treatments.
                  </p>
                  <p>
                    She educates her patients about oral hygiene practices, ensuring that dental health is maintained for the long term. Her 
                    approach is holistic, focusing not just on treatment but also on lifestyle guidance to prevent future problems.
                  </p>
                </div>

                {/* Restorative Dentistry */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Restorative Dentistry</h2>
                  <p>
                    Patients also value her expertise in restorative dentistry. As a skilled dental filling and restorative dentist near me, she has helped numerous individuals restore damaged teeth with natural-looking, long-lasting solutions. Her restorative treatments enhance both functionality and aesthetics, ensuring confident and healthy smiles.
                  </p>
                  <p>
                   With her background as a Clinic Head at Clove Dental, Dr. Chayanika has also managed complex restorative cases with exceptional precision. She has coordinated multidisciplinary treatment plans, ensured seamless patient care, and consistently delivered high-quality restorative solutions that remain accessible and affordable without compromising on excellence.
                  </p>
                </div>

                {/* Treatment Philosophy */}
                <div className="veenadoc-article-block">
                  <h2>Patient-Centered Treatment Philosophy</h2>
                  <p>
                    Her treatment philosophy centers on trust, comfort, and excellence. She believes that dentistry is not only about treating 
                    tooth problems but about transforming lives by restoring confidence, health, and smiles. This patient-first philosophy has 
                    made her one of the most recommended dentists in Bangalore.
                  </p>
                  <p>
                    Patients appreciate her transparent communication, ethical practices, and dedication to making dental care accessible to all. 
                    She continues to expand her knowledge in dentistry and stays updated with the latest techniques and technologies.
                  </p>
                </div>

                {/* Online Presence & Patient Queries */}
                <div className="veenadoc-article-block">
                  <h2>Meeting Patient Needs Online</h2>
                  <p>
                    In today's digital era, patients often search online for specific dental needs. Dr. Chayanika's profile matches these queries 
                    perfectly, as she combines advanced skills with a compassionate approach. Common searches include:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Best dentist in Jayanagar Bangalore</li>
                    <li>Female dentist near me</li>
                    <li>Root canal specialist in Bangalore</li>
                    <li>Smile designing dentist in Bangalore</li>
                    <li>Affordable dental treatment in Jayanagar</li>
                  </ul>
                  <p>
                    Her expertise aligns perfectly with these queries, ensuring that patients find exactly what they need for comprehensive dental care.
                  </p>
                </div>

                {/* Patient Reviews */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Reviews</h2>
                  <p>
                    Patients who have consulted Dr. Chayanika often describe her as approachable, skilled, and highly professional. Many reviews 
                    highlight her ability to explain treatment plans clearly, her gentle nature during procedures, and her commitment to achieving 
                    the best outcomes.
                  </p>
                  <p>
                    Her reputation as a top endodontist in Bangalore and a trusted cosmetic dentist in Jayanagar continues to grow as she helps 
                    more patients achieve lasting dental health and beautiful smiles.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Chayanika Ghosh for Excellence in Dental Care</h2>
                  <p>
                    Choosing Dr. Chayanika Ghosh means entrusting your oral health to an experienced dentist who values patient comfort, ethical 
                    practices, and clinical excellence. Whether you are searching for a root canal specialist in Jayanagar, a smile designing 
                    dentist in Bangalore, or a female dentist near me for routine check-ups, she is the ideal choice.
                  </p>
                  <p>
                    Her dedication ensures that every patient leaves not just with healthier teeth but also with greater confidence and satisfaction. 
                    Whether it is root canal therapy, cosmetic fillings, smile designing, or preventive oral care, she provides services that are 
                    both advanced and patient-friendly.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To transform lives by restoring confidence, health, and beautiful smiles through comprehensive 
                    dental care.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Dentistry is about transforming lives by restoring confidence, health, and smiles"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Chayanika Ghosh's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true dental care goes beyond treating tooth problems and requires addressing the complete oral health needs 
                    of patients. This patient-centric approach has positioned her among the best dentists in Bangalore, where she provides 
                    customised treatments for individuals of all age groups.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Jayanagar, Bangalore</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Dental Consultation</h3>
                  <p>Experience gentle and advanced dental care with Dr. Chayanika's personalized approach.</p>
                  <button
                    className="veenadoc-sidebar-btn-primary"
                    onClick={() => window.location.href = 'tel:+919964688333'}
                  >
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button
                    className="veenadoc-sidebar-btn-secondary"
                    onClick={() => window.location.href = 'tel:+919964688333'}
                  >
                    <span>💬</span>
                    <span>Get Free Consultation</span>
                  </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>


       {/* <AutoScrollImageRow/> */}

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default ChayanikaDoc
